import * as ng from 'angular';
import * as uib from 'angular-ui-bootstrap';
import * as _ from 'underscore';

import { EventsApi, EventObjectApi, NamedEventObject } from '..';
import './event-object-manager.component';

function pluralize(string) {
   function endsWith(suffix) {
      return string.indexOf(suffix, string.length - suffix.length) !== -1;
   }

   if (endsWith('s') || string.length < 2) return string;
   if (endsWith('y')) {
      var last = string[string.length - 2];
      if (!_.contains(['a', 'e', 'i', 'o', 'u'], last)) {
         return string.substring(0, string.length - 1) + 'ies';
      }
   }

   return string + 's';
}

export class EventObjectController {
   static $inject = ['$uibModal', 'eventsApi'];

   constructor(
      private $modal:uib.IModalService,
      private eventsApi:EventsApi
   ) { }

   ngModelCtrl:ng.INgModelController;

   title:string;
   resource:string;
   foreignId:number;

   data:NamedEventObject[];

   private objectApi:EventObjectApi;

   $onInit() {
      this.objectApi = this.eventsApi.getEventObjectApi(this.resource, this.foreignId);
      this.refresh();
   }

   refresh() {
      this.objectApi.list().then(data => this.data = data);
   }

   open() {
      this.$modal.open({
         component: 'eventObjectManager',
         resolve: {
            objectApi: () => this.objectApi,
            title: () => pluralize(this.title)
         }
      }).result.then(() => {
         this.refresh();
      });
   }

   get model() {
      return this.ngModelCtrl.$modelValue;
   }

   set model(val) {
      this.ngModelCtrl.$setViewValue(val);
   }
}

ng.module('e360').component('eventObject', {
   templateUrl: require('./event-object.html'),
   controller: EventObjectController,
   bindings: {
      title: '@',
      resource: '@',
      foreignId: '<',
      isRequired: '<',
   },
   require: {
      ngModelCtrl: 'ngModel'
   }
});
